<template>
    <div class="my-charts">
        <div :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";
import {markRaw} from "vue";

export default {
    name: "rtChDataChart",
    props: {
        id:{
            type: String,
            default:"rt_ch_data_echarts"
        },
        rtNum:{
            type: Number,
            default: 0
        },
        chNum:{
            type: Number,
            default: 0
        }
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
        rtNum(newValue,oldValue){
            this.rt = newValue;
            this.init()
        },
        chNum(newValue,oldValue){
            this.ch = newValue;
            this.init()
        }
    },
    data() {
        return {
            lineChart: null,
            rt:0,
            ch:0,
            chartOption:{
                tooltip: {
                    trigger: "item",
                    formatter: function(t) {
                        var e = t.data.coord[0]
                          , a = t.data.coord[1];
                        return "Rt: " + (e / 100).toFixed(3) + "<br/>Ch: " + a.toFixed(3)
                    }
                },
                grid: {
                    top: "60px",
                    left: "60px",
                    right: "60px",
                    bottom: "60px"
                },
                xAxis: {
                    name: "RT",
                    nameTextStyle: {
                        fontSize: 14,
                        color: "#000000"
                    },
                    type: "category",
                    boundaryGap: false,
                    axisLabel: {
                        fontSize: 14,
                        color: "#000000",
                        formatter: function(t, e) {
                            switch (t) {
                                case "0.3":
                                case "0.7":
                                case "1":
                                    return t;
                                default:
                                    return ""
                            }
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#134873",
                            type: "dashed"
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#134873",
                            opacity: .2
                        }
                    },
                    data: [],
                },
                yAxis: {
                    name: "CH",
                    type: "value",
                    nameTextStyle: {
                        fontSize: 14
                    },
                    axisLabel: {
                        fontSize: 14,
                        color: "#000000"
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#000000"
                        }
                    },
                    splitLine: {
                        interval: .1,
                        lineStyle: {
                            color: "#134873",
                            opacity: .2
                        }
                    }
                },
                graphic:[
                    {
                        type: "text",
                        left: "20%",
                        bottom: "18%",
                        style: {
                            font: "18px sans-serif",
                            fill: "#000000",
                            text: "练习型",
                            size: 20
                        }
                    }, {
                        type: "text",
                        right: "20%",
                        bottom: "18%",
                        style: {
                            font: '18px "STHeiti", sans-serif',
                            fill: "#000000",
                            text: "讲授型",
                            size: 20
                        }
                    },{
                        type: "text",
                        left: "47%",
                        bottom: "22%",
                        style: {
                            font: "18px sans-serif",
                            fill: "#000000",
                            text: "混合型",
                            size: 20
                        }
                    }, {
                        type: "text",
                        left: "47%",
                        bottom: "55%",
                        style: {
                            font: "18px sans-serif",
                            fill: "#000000",
                            text: "对话型",
                            size: 20
                        }
                    }
                ],
                series: [
                    {
                        type: "line",
                        symbolSize: 0,
                        lineStyle: {
                            color: "#57B5FF"
                        },
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    },
                    {
                        type: "line",
                        symbolSize: 0,
                        lineStyle: {
                            color: "#57B5FF"
                        },
                        data: [0, .02, .04, .06, .08, .1, .12, .14, .16, .18, .2, .22, .24, .26, .28, .3, .32, .34, .36, .38, .4, .42, .44, .46, .48, .5, .52, .54, .56, .58, .6, .62, .64, .66, .68, .7, .72, .74, .76, .78, .8, .82, .84, .86, .88, .9, .92, .94, .96, .98, 1, .98, .96, .94, .92, .9, .88, .86, .84, .82, .8, .78, .76, .74, .72, .7, .68, .66, .64, .62, .6, .58, .56, .54, .52, .5, .48, .46, .44, .42, .4, .38, .36, .34, .32, .3, .28, .26, .24, .22, .2, .18, .16, .14, .12, .1, .08, .06, .04, .02, 0]
                    },
                    {
                        type: "line",
                        symbolSize: 0,
                        lineStyle: {
                            color: "#57B5FF"
                        },
                        data: [0, .02, .04, .06, .08, .1, .12, .14, .16, .18, .2, .22, .24, .26, .28, .3, .32, .34, .36, .38, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .4, .38, .36, .34, .32, .3, .28, .26, .24, .22, .2, .18, .16, .14, .12, .1, .08, .06, .04, .02, 0]
                    },
                    {
                        type: "line",
                        symbolSize: 0,
                        step: "end",
                        lineStyle: {
                            color: "#57B5FF"
                        },
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, .6]
                    },
                    {
                        type: "line",
                        symbolSize: 0,
                        step: "end",
                        lineStyle: {
                            color: "#57B5FF"
                        },
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, .6],
                        markPoint: {
                            symbol: "circle",
                            symbolSize: 14,
                            itemStyle: {
                                color: "red",
                                opacity: .8
                            },
                            data: [{
                                coord: []
                            }]
                        }
                    }
                ],
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            this.rt = this.rtNum;
            this.ch = this.chNum;
            this.chartOption.xAxis.data = Array(101).fill("").map(function (t, e) {
                return Number(10 * e / 1e3)
            });
            if (!(this.rt>0&&this.ch>0)){
                return;
            }
            this.chartOption.series[4].markPoint.data[0].coord = [this.rt, this.ch / 100];
            this.chartList = this.dataList;
            this.lineChart = markRaw(echarts.init(document.getElementById(this.id)));
            this.lineChart.setOption(this.chartOption);
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    color: #333!important;
    display: flex;
    > div {
        width: 650px;
        height: 680px;
        margin: auto;
    }
    div + div {
        margin-left: 10px;
    }
}
</style>